import { render, staticRenderFns } from "./PortalShops.vue?vue&type=template&id=0b87a143&scoped=true&"
import script from "./PortalShops.vue?vue&type=script&lang=js&"
export * from "./PortalShops.vue?vue&type=script&lang=js&"
import style0 from "./PortalShops.vue?vue&type=style&index=0&id=0b87a143&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87a143",
  null
  
)

export default component.exports